import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      getSelectedClients: 'client/getSelectedClients',
      hasCreateBookingPermissionForAtleastOneClientLocationByClientIds:
        'auth/hasCreateBookingPermissionForAtleastOneClientLocationByClientIds',
    }),
    canCreateBookings() {
      return this.hasCreateBookingPermissionForAtleastOneClientLocationByClientIds(
        this.getSelectedClients
      )
    },
    columns() {
      const headers = [
        {
          id: 'booking-list-table__id',
          value: 'id',
          text: this.$t('booking.idLabel'),
          align: 'left',
          width: '12%',
          display: true,
        },
        {
          id: 'booking-list-table__name',
          value: 'name',
          text: this.$t('booking.nameLabel'),
          align: 'left',
          width: '14%',
          display: true,
        },
        {
          id: 'booking-list-table__time',
          value: 'time',
          text: this.$t('booking.timeLabel'),
          align: 'left',
          width: '8%',
          display: true,
        },
        {
          id: 'booking-list-table__type',
          value: 'type',
          text: this.$t('booking.typeLabel'),
          align: 'left',
          width: '12%',
          display: true,
        },
        {
          id: 'booking-list-table__grades',
          value: 'grades',
          text: this.$t('booking.gradesLabel'),
          align: 'left',
          width: '10%',
          display: true,
        },
        {
          id: 'booking-list-table__certifications',
          value: 'certifications',
          text: this.$t('booking.certificationsLabel'),
          align: 'left',
          width: '10%',
          display: true,
        },
        {
          id: 'booking-list-table__policies',
          value: 'policies',
          text: this.$t('booking.policiesLabel'),
          align: 'left',
          width: '10%',
          display: true,
        },
        {
          id: 'booking-list-table__replacing',
          value: 'replacing',
          text: this.$t('booking.replacingLabel'),
          align: 'left',
          width: '12%',
          display: true,
        },
        {
          id: 'booking-list-table__feedback',
          value: 'feedback',
          text: this.$t('booking.feedbackLabel'),
          align: 'left',
          width: '8%',
          display: this.canCreateBookings,
        },
        {
          id: 'booking-list-table__actions',
          value: 'actions',
          text: null,
          align: 'right',
          width: '4%',
          display: this.canCreateBookings,
        },
      ]

      return headers.filter((header) => header.display)
    },
  },
}
